var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#9486DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54491 19.2042C8.40091 19.2042 8.26091 19.1454 8.15891 19.0361C8.02891 18.9018 7.97491 18.7065 8.01091 18.5196L8.52491 15.819C8.54491 15.7077 8.59691 15.6048 8.67291 15.525L16.2089 7.61425C16.9889 6.79525 18.2569 6.79525 19.0389 7.61425C19.4149 8.01115 19.6229 8.53825 19.6229 9.09895C19.6229 9.66175 19.4149 10.1889 19.0369 10.5858L11.5029 18.4965C11.4269 18.5763 11.3289 18.6308 11.2249 18.654L8.65291 19.1937C8.61691 19.2021 8.58091 19.2042 8.54491 19.2042ZM11.1169 18.0912H11.1249H11.1169ZM9.56091 16.2138L9.24091 17.9022L10.8489 17.5641L18.2669 9.77515C18.4389 9.59455 18.5329 9.35515 18.5329 9.09895C18.5329 8.84485 18.4389 8.60545 18.2669 8.42485C17.9129 8.05315 17.3349 8.05315 16.9809 8.42485L9.56091 16.2138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6259 11.8331C17.4859 11.8331 17.3459 11.7785 17.2399 11.6651L15.1839 9.50422C14.9699 9.28162 14.9699 8.91832 15.1839 8.69362C15.3959 8.47102 15.7419 8.47102 15.9559 8.69362L18.0119 10.8545C18.2259 11.0792 18.2259 11.4425 18.0119 11.6651C17.9059 11.7764 17.7659 11.8331 17.6259 11.8331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.5d9c12cc3aaf1a7cb0406e57da3c8b61.svg";
export { ForwardRef as ReactComponent };